<template>
  <ShoppingAssistantChat
    :entry-point
    :initial-chat-id
    :is-seeded-launch
    :page-context
    :seeded-message
  />

  <!-- Shared confirmation for both new-chat and close (gated on a non-empty
       conversation by the web-page host adapter). Rendered above the page by
       the DS portal so it is never occluded. -->
  <RevDialog
    :name="WEB_PAGE_CONFIRM_DIALOG_NAME"
    :title="currentDialog?.title ?? ''"
  >
    <template #body>
      <p class="body-1">{{ currentDialog?.description }}</p>
    </template>

    <template #footer>
      <RevButton full-width="always" variant="primary" @click="acceptDialog">
        {{ currentDialog?.acceptButtonText }}
      </RevButton>
      <RevButton
        class="mt-12"
        full-width="always"
        variant="secondary"
        @click="declineDialog"
      >
        {{ currentDialog?.declineButtonText }}
      </RevButton>
    </template>
  </RevDialog>
</template>

<script lang="ts" setup>
import { provide } from 'vue'

import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'

import type { ChatRequestPageContext } from '~/api/shopping-assistant/types'

import type { EntryPoint } from '../composables/useShoppingAssistantContext'
import { SHOPPING_ASSISTANT_HOST_KEY } from '../composables/useShoppingAssistantHost.injection-key'
import {
  WEB_PAGE_CONFIRM_DIALOG_NAME,
  useWebPageShoppingAssistantHost,
} from '../composables/useWebPageShoppingAssistantHost'
import ShoppingAssistantChat from '../pages/ShoppingAssistantChat.vue'

defineProps<{
  entryPoint: EntryPoint
  initialChatId: string | null
  isSeededLaunch: boolean
  pageContext: ChatRequestPageContext | null
  seededMessage: string
}>()

const { host, currentDialog, acceptDialog, declineDialog } =
  useWebPageShoppingAssistantHost()
provide(SHOPPING_ASSISTANT_HOST_KEY, host)
</script>
